import { useState } from 'react';
import { Button, Card, Grid, Group, Select, TextInput } from '@mantine/core';
import shipmentProviders from '../../../constants/shipmentProviders';
import PreviewOrderStatusPageModal from '../../Modals/PreviewOrderStatusPageModal';

const SettingsTabShipmentProvider = ({ domain, handleChange }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const shipmentProviderOptions = [
    { value: '', label: 'Please select a shipment provider' },
    ...shipmentProviders.map((provider) => ({ value: provider, label: provider })),
  ];

  return (
    <Card withBorder>
      <PreviewOrderStatusPageModal
        show={isModalVisible}
        close={() => setIsModalVisible(false)}
        baseUrl={domain.shipmentStatusPageUrl}
      />

      <Card.Section p="md">
        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 4 }} style={{ display: 'flex', alignItems: 'center' }}>
            <label>Shipment Provider</label>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <Select
              name="shipmentProvider"
              data={shipmentProviderOptions}
              value={domain.shipmentProvider || ''}
              onChange={(value) => handleChange({ target: { name: 'shipmentProvider', value } })}
            />
          </Grid.Col>
        </Grid>
        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 4 }} style={{ display: 'flex', alignItems: 'center' }}>
            <label>Access Token</label>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <TextInput
              name="shipmentAccessToken"
              autoComplete="nope"
              value={domain.shipmentAccessToken || ''}
              onChange={handleChange}
            />
          </Grid.Col>
        </Grid>
        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 4 }} style={{ display: 'flex', alignItems: 'center' }}>
            <label>Shipment Status Page URL</label>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <Group gap="xs">
              <TextInput
                name="shipmentStatusPageUrl"
                autoComplete="nope"
                value={domain.shipmentStatusPageUrl || ''}
                onChange={handleChange}
                style={{ flex: 1 }}
              />
              <Button disabled={!domain.shipmentStatusPageUrl} onClick={() => setIsModalVisible(true)}>
                Preview
              </Button>
            </Group>
          </Grid.Col>
        </Grid>
      </Card.Section>
    </Card>
  );
};

export default SettingsTabShipmentProvider;
